<template>
    <b-modal
        id="boarding-preview-modal"
        no-fade
        ref="modal"
        :lazy="true"
        :no-close-on-backdrop="true"
        :scrollable="true"
        title-tag="h2"
        title="Reservation"
        modal-class="reservation-preview"
    >
        <preview
            :details="details"
            :providers="providers"
            @details-loaded="detailsLoaded"
        />

        <template v-slot:modal-footer>
            <preview-footer
                @edit="$emit('edit', details)"
                @checkin="$emit('checkin', details)"
                @checkout="$emit('checkout', details.id)"
                @undo="$emit('undo', details.id)"
                @cagecard="$emit('cagecard', details.id)"
                @split="$emit('split', details.id)"
                @cancel="$emit('cancel', details.id)"
                @extend="$emit('extend', details.id)"
                :status="details.status"
                :boarding="boarding"
            />
        </template>
    </b-modal>
</template>

<script>
import Preview from "./reservation-preview.vue";
import PreviewFooter from "./reservation-preview-footer.vue";

export default {
    components: {
        Preview,
        PreviewFooter
    },
    data() {
        return {
            isLoadingFooter: false,
            providers: [],
            details: {},
            boarding: null
        };
    },
    methods: {
        open({ providers, details }) {
            this.$refs.modal.show();
            this.providers = providers;
            this.details = details;
        },
        detailsLoaded(boarding) {
            this.boarding = boarding;
        }
    }
};
</script>

<style scoped>
::v-deep .modal-footer {
    justify-content: flex-start;
    padding-top: 13px !important;
    padding-bottom: 13px !important;
}
::v-deep .modal-body {
    padding: 0;
}
::v-deep .reservation-preview .modal-dialog {
    min-width: 550px;
    width: 550px;
}
</style>
